<template>
  <div>
    <div class="clearfix">
      <div class="m-b-xs" v-if="typeof addButton === 'string' || typeof deleteButton === 'string'">
        <div class="clearfix">
          <div data-toggle="buttons" class="pull-right">
            <Button
              v-if="routeName && typeof addButton === 'string'"
              :href="{ name: routeName, params: { type: 'cadastrar' } }"
              title="Novo"
              variant="info"
              size="sm">
              <i class="fa fa-plus"></i> Novo
            </Button>

            <Button
              v-if="typeof deleteButton === 'string' && getUserData && getUserData.level_access === 3"
              title="Excluir"
              variant="danger"
              size="sm"
              :disabled="checkedItems.length === 0"
              @onClick="confirmDeleteRecords">
              <i class="fa fa-trash"></i> Excluir
            </Button>
          </div>
        </div>

        <div v-if="typeof filter === 'string'">
          <br>

          <div class="row">
            <div class="col-sm-1">
              <select class="input-sm form-control input-s-sm inline" ref="perPage" @change="resultsPerPage">
                <option value="10" :selected="resPerPage == 10">10</option>
                <option value="25" :selected="resPerPage == 25">25</option>
                <option value="50" :selected="resPerPage == 50">50</option>
                <option value="100" :selected="resPerPage == 100">100</option>
              </select>
            </div>

            <div class="col-sm-2">
              <select class="input-sm form-control input-s-sm inline" ref="perType" @change="filterPerStatus" v-if="statusList">
                <option value="-1" :selected="resPerStatus == -1">Todos</option>
                <option
                  v-for="(item, index) in statusList"
                  :key="index"
                  :value="item.id"
                  :selected="resPerStatus == item.id">{{ item.name }}</option>
              </select>
            </div>

            <div class="col-sm-4 col-sm-offset-5">
              <form @submit.prevent="getKeyword">
                <div class="input-group">
                  <input type="search" class="input-sm form-control" v-model="search" @blur="getKeyword" @keyup="getKeyword">
                  <span class="input-group-btn">
                    <button type="submit" class="btn btn-default btn-sm">
                      <span class="fa fa-search"></span>
                    </button>
                  </span>
                </div>
              </form>
            </div><!-- /.col -->
          </div><!-- /.row -->
        </div>
      </div><!-- /.col -->
    </div>

    <br>

    <div class="table-responsive">
      <table class="table table-striped table-hover table-bordered" :class="{ 'table-sort': typeof sort === 'string' && rows.length > 0 }">
        <thead>
          <tr>
            <th style="width: 50px" class="text-nowrap text-center" v-if="typeof deleteButton === 'string'">
              <span v-if="getUserData && getUserData.level_access !== 3">ID</span>
            </th>
            <th
              v-for="(column, index) in columns" :key="index"
              class="text-nowrap"
              @click="orderBy"
              :data-th-name="column.name"
              :data-th-label="column.label"
              data-th-order="none">
              {{ column.label }}
            </th>
            <th v-if="typeof editButton === 'string' || typeof deleteButton === 'string'" style="width: 100px" class="text-center">Ações</th>
          </tr>
        </thead>

        <tbody v-if="rows.length === 0">
          <tr>
            <td :colspan="columns.length + 2">Nenhum resultado encontrado.</td>
          </tr>
        </tbody>

        <tbody v-else>
          <tr v-for="(keys, index) in rows" :key="index">
            <td v-for="(key, index) in keys" :key="index">
              <div v-if="index === 'id' && getUserData && getUserData.level_access === 3" class="text-center block">
                <label class="custom-checkbox" v-if="typeof deleteButton === 'string'">
                  <input type="checkbox" v-model="checkedItems" :value="key">
                  <span class="checkmark"></span>
                </label>

                <span v-else v-html="key" class="text-left block"></span>
              </div>
              <span v-else v-html="key"></span>
            </td>

            <td class="text-center" v-if="typeof editButton === 'string' || typeof deleteButton === 'string'">
              <Button
                v-if="routeNameEdit && typeof editButton === 'string' && typeof editButtonDefaultUrl === 'string'"
                :href="{ name: routeNameEdit, params: { id: keys['id'] } }"
                title="Editar"
                variant="success"
                size="sm"
                data-toggle="tooltip">
                <i class="fa fa-pencil"></i>
              </Button>

              <Button
                v-if="routeName && typeof editButton === 'string' &&  typeof editButtonDefaultUrl !== 'string'"
                :href="{ name: routeName, params: { type: 'editar', id: keys['id'] } }"
                title="Editar"
                variant="success"
                size="sm"
                data-toggle="tooltip">
                <i class="fa fa-pencil"></i>
              </Button>

              <Button
                v-if="typeof deleteButton === 'string' && getUserData && getUserData.level_access === 3"
                title="Excluir"
                variant="danger"
                size="sm"
                data-toggle="tooltip"
                @onClick="confirmDeleteRecord(keys['id'])">
                <i class="fa fa-trash"></i>
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    </div><!-- /.table-responsive -->

    <!-- <div class="clearfix" v-if="pagination && totalPages > 1"> -->
    <div class="clearfix">
      <div class="table-status">
        <span v-if="pagination"><strong>{{ totalItems }}</strong> registros encontrados</span>
        <span v-else><strong>{{ rows.length }}</strong> registros encontrados</span>
      </div>

      <nav aria-label="Paginação" class="table-pagination" v-if="routeName && pagination && totalPages > 1">
        <ul class="pagination">
          <li :class="{ 'disabled': actualPage === 1 }">
            <router-link :to="{ name: routeName, params: { type: 'listar', page: 1 } }" title="Primeira página">
              <span aria-hidden="true">&laquo;</span>
            </router-link>
          </li>

          <li :class="{ 'disabled': actualPage === 1 || actualPage === 2 }">
            <router-link
              :to="{ name: routeName, params: { type: 'listar', page: ((actualPage === 1 || actualPage === 2) ? 1 : actualPage - 2) } }"
              title="Página anterior">
              &lsaquo;
            </router-link>
          </li>

          <li v-if="actualPage >  1">
            <router-link
              :to="{ name: routeName, params: { type: 'listar', page: (actualPage === 1 ? 1 : actualPage - 1) } }"
              :title="`Página ${(actualPage === 1 ? 1 : actualPage - 1)}`">
              {{ (actualPage === 1 ? 1 : actualPage - 1) }}
            </router-link>
          </li>

          <li class="active">
            <a href="#" :title="`Página ${actualPage}`" @click.prevent>{{ actualPage }}</a>
          </li>

          <li v-if="(actualPage + 1 <= totalPages)">
            <router-link
              :to="{ name: routeName, params: { type: 'listar', page: (actualPage + 1) } }"
              :title="`Página ${(actualPage + 1)}`">
              {{ actualPage + 1 }}
            </router-link>
          </li>

          <li :class="{ 'disabled': actualPage === totalPages }">
            <router-link
              :to="{ name: routeName, params: { type: 'listar', page: (actualPage + 2) > totalPages ? totalPages : actualPage + 2 } }"
              title="Próxima página">
              &rsaquo;
            </router-link>
          </li>

          <li :class="{ 'disabled': actualPage === totalPages }">
            <router-link :to="{ name: routeName, params: { type: 'listar', page: totalPages } }" title="Última página">
              <span aria-hidden="true">&raquo;</span>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tables',
  props: {
    routeName: {
      required: true,
      type: String
    },
    routeNameEdit: {
      type: String,
      default: null
    },
    columns: {
      required: true,
      type: Array
    },
    rows: {
      required: true,
      type: Array
    },
    filter: {
      type: String,
      default: null
    },
    searchValue: {
      type: String,
      default: null
    },
    statusList: {
      type: Array,
      default: null
    },
    pagination: {
      type: Object,
      default: null
    },
    resPerPage: {
      type: [Number, String]
    },
    resPerStatus: {
      type: [Number, String]
    },
    sort: {
      type: String,
      default: null
    },
    addButton: {
      type: String,
      default: null
    },
    deleteButton: {
      type: String,
      default: null
    },
    editButton: {
      type: String,
      default: null
    },
    editButtonDefaultUrl: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      perType: null,
      search: null,
      checkedItems: []
    }
  },
  computed: {
    actualPage () {
      return parseInt(this.pagination.actualPage)
    },
    totalPages () {
      return parseInt(this.pagination.totalPages)
    },
    totalItems () {
      return parseInt(this.pagination.totalItems)
    },
    getUserData () {
      return this.$store.state.userData
    }
  },
  methods: {
    // map methods components
    resultsPerPage () {
      this.$emit('resultsPerPage', this.$refs.perPage.value)
    },
    filterPerStatus () {
      this.$emit('filterPerStatus', this.$refs.perType.value)
    },
    getKeyword (e) {
      if (e.type === 'keyup') {
        if (!this.search) {
          this.$emit('getKeyword', this.search)
        }
      }

      if (e.type === 'blur' || e.type === 'submit') {
        if (this.search) {
          this.$emit('getKeyword', this.search)
        }
      }
    },
    orderBy (e) {
      if (typeof this.sort === 'string') {
        // reset table
        const thOrder = e.target.dataset.thOrder
        $('th[data-th-order]').removeClass('active')
        $('tbody td').removeClass('active')

        // active target column
        $('th[data-th-order]').attr('data-th-order', 'none')
        e.target.setAttribute('class', 'active')
        $(`tbody td:nth-child(${e.target.cellIndex + 1})`).addClass('active')

        if (thOrder === 'desc' || thOrder === 'none') {
          e.target.setAttribute('data-th-order', 'asc')
        }

        if (thOrder === 'asc') {
          e.target.setAttribute('data-th-order', 'desc')
        }

        const data = {
          thName: e.target.dataset.thName,
          thLabel: e.target.dataset.thLabel,
          thOrder: e.target.dataset.thOrder
        }

        this.$emit('orderBy', data)
      }
    },
    confirmDeleteRecord (item) {
      this.$emit('confirmDeleteRecords', [item])
    },
    confirmDeleteRecords () {
      this.$emit('confirmDeleteRecords', this.checkedItems)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/mixins';

.table-sort > thead > tr > th[data-th-order] {
  cursor: pointer;
  @include transition(background-color .16s);
}

.table-sort > thead > tr > th[data-th-order].active {
  background-color: rgba(#f2f2f2, .6);
}

.table-sort > thead > tr > th[data-th-order] {
  position: relative;

  &:before {
    display: inline-block;
    font: normal normal normal 14px/1 FontAwesome;
    font-size: inherit;
    text-rendering: auto;
    position: absolute;
    right: 8px;
    top: 50%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    @include transform(translateY(-50%));
  }

  &[data-th-order="none"] {

    &:before {
      content: "\f0dc";
    }
  }

  &[data-th-order="asc"] {

    &:before {
      content: "\f0d8";
    }
  }

  &[data-th-order="desc"] {

    &:before {
      content: "\f0d7";
    }
  }
}

.table-sort > tbody > tr > td.active {
  background-color: rgba(#f2f2f2, .6);
  @include transition(background-color .16s);
}

.table-status {
  float: left;
  font-size: 11.5px;
  margin-top: 8px;
}

.table-pagination {
  float: right;

  .pagination {
    margin: 0;
  }
}

.table-sort > thead > tr > th {
  padding-right: 23px;
}

.custom-checkbox {
  margin-bottom: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/tables/Tables.vue